import { InterfaceElement, ComponentStructure } from './styles'

import { CardProps } from './type'

const DocumentListCard = ({
  children,
  spacingClass = 'regular',
  fullHeight,
  ...props
}: CardProps & React.HTMLAttributes<HTMLDivElement>) => (
  <InterfaceElement fullHeight={fullHeight}>
    <ComponentStructure
      spacingClass={spacingClass}
      fullHeight={fullHeight}
      {...props}
    >
      {children}
    </ComponentStructure>
  </InterfaceElement>
)

export default DocumentListCard
